<div class="container-fluid">
  <div class="page-title">
    <div class="row">
      <div [class.col-6]="showTrail" [class.col-12]="!showTrail">
        <h3>{{ title }}</h3>
      </div>
      <div class="col-6" *ngIf="showTrail">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a routerLink="/dashboard/dashboard">
              <app-svg-icon [icon]="'home'"></app-svg-icon>
            </a>
          </li>
          <li class="breadcrumb-item" *ngFor="let item of items">{{ item }}</li>
          <li class="breadcrumb-item active" style="color: #fe0000;" *ngIf="active_item">{{ active_item }}</li>
        </ol>
      </div>
    </div>
  </div>
</div>
